import axios from 'axios';

const ApiService = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  withCredentials: true,
});

export default ApiService;
